<template>
  <PageWrapper :isLoading="isLoading" isDense isTransparent>
    <template #title> جزئیات کلاس ترمیک </template>
    <PageWrapper isChildWrapper v-if="termicCourseDetails">
      <template #title> تنظیمات کلی </template>
      <BRow>
        <BCol cols="12" md="6">
          <TextInput
            inputId="termicCourseName"
            inputLabel="عنوان کلاس"
            inputPlaceholder="کلاس ترمیک آیلتس مقدماتی"
            v-model="termicCourseDetails.termicCourseName"
          ></TextInput>
        </BCol>
        <BCol cols="12" md="6">
          <LanguagePicker
            placeHolder="زبان کلاس ترمیک"
            :defaultLanguageId="termicCourseDetails.language.languageId"
            @getLanguage="setTermicCourseLanguage"
          ></LanguagePicker>
        </BCol>

        <BCol cols="12" md="6">
          <MasterPicker @getMaster="setMasterUserId"></MasterPicker>
        </BCol>

        <BCol cols="12" md="6">
          <TextInput
            inputId="sessions"
            inputLabel="تعداد جلسات"
            inputPlaceholder="8"
            inputMode="numeric"
            v-model="termicCourseDetails.sessions"
            type="number"
          >
            <template #append> جلسه </template>
          </TextInput>
        </BCol>

        <BCol cols="12">
          <TextInput
            inputId="masterIncome"
            inputLabel="درآمد استاد"
            inputPlaceholder="200,000"
            inputMode="numeric"
            v-model="formattedMasterIncome"
            type="text"
          >
            <template #append> تومان </template>
          </TextInput>
        </BCol>

        <BCol cols="12" md="6">
          <BRow>
            <BCol cols="6">
              <CustomDatePicker
                type="time"
                inputId="startTime"
                inputLabel="ساعت شروع کلاس"
                inputPlaceholder="14:30"
                :value="termicCourseDetails.startTime"
                @getSelectedDate="setTermicCourseStartTime"
              ></CustomDatePicker>
            </BCol>
            <BCol cols="6">
              <CustomDatePicker
                type="time"
                inputId="endTime"
                inputLabel="ساعت پایان کلاس"
                inputPlaceholder="16:30"
                :value="termicCourseDetails.endTime"
                @getSelectedDate="setTermicCourseEndTime"
              ></CustomDatePicker>
            </BCol>
          </BRow>
        </BCol>
        <BCol cols="12" md="6">
          <WeekDaysCheckBoxGroup
            inputLabel="روز های برگزاری کلاس"
            v-model="termicCourseDetails.days"
          ></WeekDaysCheckBoxGroup>
        </BCol>
        <!-- تاریخ شروع و پایان دوره -->
        <BCol cols="12" md="6">
          <BRow>
            <BCol cols="6">
              <CustomDatePicker
                type="date"
                inputId="startDate"
                inputLabel="تاریخ شروع کلاس"
                inputPlaceholder="1405/07/20"
                :value="termicCourseDetails.startDate"
                @getSelectedDate="setTermicCourseStartDate"
              ></CustomDatePicker>
            </BCol>
            <BCol cols="6">
              <CustomDatePicker
                type="date"
                inputId="endDate"
                inputLabel="تاریخ پایان کلاس"
                inputPlaceholder="1405/09/20"
                :value="termicCourseDetails.endDate"
                @getSelectedDate="setTermicCourseEndDate"
              ></CustomDatePicker>
            </BCol>
          </BRow>
        </BCol>
      </BRow>
    </PageWrapper>

    <PageWrapper isChildWrapper v-if="termicCourseDetails">
      <template #title> تنظیمات زبان آموز </template>
      <BRow>
        <BCol cols="12" md="6">
          <TextInput
            inputId="minUserCapacity"
            inputLabel="حداقل تعداد شرکت کننده"
            inputPlaceholder="4"
            inputMode="numeric"
            v-model="termicCourseDetails.minUserCapacity"
            type="number"
          >
            <template #append> نفر </template>
          </TextInput>
        </BCol>

        <BCol cols="12" md="6">
          <TextInput
            inputId="maxUserCapacity"
            inputLabel="حداکثر تعداد شرکت کننده"
            inputPlaceholder="8"
            inputMode="numeric"
            v-model="termicCourseDetails.maxUserCapacity"
            type="number"
          >
            <template #append> نفر </template>
          </TextInput>
        </BCol>

        <BCol cols="12" md="6">
          <TextInput
            inputId="price"
            inputLabel="قیمت کلاس ترمیک"
            inputPlaceholder="1,000,000"
            inputMode="numeric"
            v-model="formattedTermicCoursePrice"
            type="text"
          >
            <template #append> تومان </template>
          </TextInput>
        </BCol>

        <BCol cols="12" md="6">
          <BRow>
            <BCol cols="6">
              <TextInput
                inputId="discountPrice"
                inputLabel="قیمت کلاس ترمیک با تخفیف"
                inputPlaceholder="700,000"
                inputMode="numeric"
                v-model="formattedTermicCourseDiscountPrice"
                type="text"
              >
                <template #append> تومان </template>
              </TextInput>
            </BCol>
            <BCol cols="6">
              <TextInput
                inputId="discountPriceConditionCount"
                inputLabel="تعداد نفرات شامل تخفیف"
                inputPlaceholder="5"
                inputMode="numeric"
                v-model="termicCourseDetails.discountPriceConditionCount"
                type="number"
              >
                <template #append> نفر </template>
              </TextInput>
            </BCol>
          </BRow>
        </BCol>
      </BRow>
    </PageWrapper>

    <PageWrapper isChildWrapper v-if="termicCourseDetails">
      <template #title> تنظیمات عمومی </template>
      <BRow>
        <BCol cols="12">
          <BFormGroup label="تصویر نمایشی کلاس" label-for="imageFile">
            <BFormFile
              v-model="uploadImagePayload.imageFile"
              ref="imageFile"
              id="imageFile"
              accept=".jpg,.jpeg,.png"
              @input="handleImageFile"
            ></BFormFile>
          </BFormGroup>
        </BCol>
        <BCol cols="12" class="position-relative" v-if="imagePreview">
          <BImg
            v-if="imagePreview"
            rounded
            class="custom-image"
            center
            fluid
            :src="imagePreview"
          ></BImg>
          <BButton
            size="sm"
            variant="transparent"
            class="custom-delete-btn"
            @click="deletePreviewImage"
          >
            <FeatherIcon size="40" class="text-danger" icon="Trash2Icon" />
          </BButton>
        </BCol>
        <template v-if="defaultImage">
          <BCol cols="12">
            <hr />
          </BCol>
          <BCol cols="12" class="mt-1">
            <label> تصویر فعلی کلاس </label>
            <div class="d-flex align-items-center justify-content-center">
              <BImg
                rounded
                class="custom-image mx-auto"
                fluid
                :src="defaultImage"
              ></BImg>
            </div>
          </BCol>
        </template>
        <BCol cols="12">
          <CustomEditor
            label="توضیحات کلاس ترمیک"
            v-model="termicCourseDetails.termicCourseDescription"
          ></CustomEditor>
        </BCol>
        <BCol cols="12" class="d-flex align-items-center justify-content-end">
          <BButton variant="update" @click="updateTermicCourseDetails">
            ویرایش کلاس ترمیک
          </BButton>
        </BCol>
      </BRow>
    </PageWrapper>

    <TermicCourseStudentList
      :termicCourseId="$route.params.id"
    ></TermicCourseStudentList>
  </PageWrapper>
</template>

<script>
export default {
  mounted() {
    this.getTermicCourseDetails();
  },
  data() {
    return {
      isLoading: false,
      termicCourseDetails: null,
      imagePreview: null,
      defaultImage: null,
      uploadImagePayload: {
        imageFile: null,
        fileType: 0,
        title: null,
        alt: null,
        description: null,
      },
    };
  },
  methods: {
    formatInitialPrices() {
      this.formattedTermicCoursePrice = `${this.termicCourseDetails.price}`;
      this.formattedTermicCourseDiscountPrice = `${this.termicCourseDetails.discountPrice}`;
      this.formattedMasterIncome = `${this.termicCourseDetails.masterIncome}`;
    },
    async generateImageFormData() {
      return new Promise((resolve, reject) => {
        this.uploadImagePayload.title =
          this.termicCourseDetails.termicCourseName;
        this.uploadImagePayload.alt = this.termicCourseDetails.termicCourseName;
        this.uploadImagePayload.description =
          this.termicCourseDetails.termicCourseDescription;

        const myFormData = new FormData();
        Object.keys(this.uploadImagePayload).forEach((key) => {
          myFormData.append(key, this.uploadImagePayload[key]);
        });
        resolve(myFormData);
      });
    },
    handleImageFile() {
      if (this.uploadImagePayload.imageFile) {
        this.imagePreview = URL.createObjectURL(
          this.uploadImagePayload.imageFile
        );
      }
    },
    deletePreviewImage() {
      if (this.uploadImagePayload && this.uploadImagePayload.imageFile) {
        URL.revokeObjectURL(this.imagePreview);
        this.imagePreview = null;
        this.uploadImagePayload.imageFile = null;
        if (this.$refs.imageFile && this.$refs.imageFile) {
          this.$refs.imageFile.reset();
        }
      }
    },
    async uploadTermicCourseImage() {
      try {
        this.isLoading = true;
        const _this = this;
        const uploadImage = new UploadImage(_this);
        uploadImage.setFormData(await _this.generateImageFormData());
        await uploadImage.sendFormData((res) => {
          if (res.data.url) {
            this.termicCourseDetails.imageUrl = res.data.url;
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    generateTermicCoursePayload() {
      // This method is used to sanitize payload, like removing
      // commas from price, etc.
      const newPayload = { ...this.termicCourseDetails };

      if (newPayload.price)
        newPayload.price = newPayload.price.replaceAll(",", "");

      if (newPayload.discountPrice)
        newPayload.discountPrice = newPayload.discountPrice.replaceAll(",", "");

      if (newPayload.masterIncome)
        newPayload.masterIncome = newPayload.masterIncome.replaceAll(",", "");

      if (newPayload.language.languageId) {
        newPayload.languageId = newPayload.language.languageId;
      }

      newPayload.masterUserId = newPayload.masterUser.masterUserId;

      delete newPayload.language;
      delete newPayload.masterUser;

      return newPayload;
    },
    async getTermicCourseDetails() {
      try {
        this.isLoading = true;
        const _this = this;
        const getTermicCourseById = new GetTermicCourseById(_this);
        getTermicCourseById.setRequestParam({
          termicCourseId: _this.$route.params.id,
        });
        await getTermicCourseById.fetch((res) => {
          _this.termicCourseDetails = res.data;
          if (_this.termicCourseDetails.imageUrl) {
            _this.defaultImage = _this.termicCourseDetails.imageUrl;
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
        this.formatInitialPrices();
      }
    },
    async updateTermicCourseDetails() {
      try {
        this.isLoading = true;
        const _this = this;
        if (this.uploadImagePayload.imageFile) {
          await this.uploadTermicCourseImage();
        }
        const updateTermicCourse = new UpdateTermicCourse(_this);
        updateTermicCourse.setRequestParamDataObj(
          _this.generateTermicCoursePayload()
        );
        await updateTermicCourse.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "کلاس ترمیک با موفقیت ویرایش شد",
                icon: "CheckIcon",
                variant: "success",
              },
            });
            _this.deletePreviewImage();
            _this.getTermicCourseDetails();
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ویرایش نشد!",
                icon: "AlertCircleIcon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    setTermicCourseLanguage(languageId) {
      this.termicCourseDetails.languageId = languageId;
    },
    setTermicCourseStartDate(startDate) {
      this.termicCourseDetails.startDate = new Date(startDate).toISOString();
    },
    setTermicCourseEndDate(endDate) {
      this.termicCourseDetails.endDate = new Date(endDate).toISOString();
    },
    setTermicCourseStartTime(startTime) {
      this.termicCourseDetails.startTime = new Date(startTime).toISOString();
    },
    setTermicCourseEndTime(endTime) {
      this.termicCourseDetails.endTime = new Date(endTime).toISOString();
    },
    setMasterUserId(master) {
      this.termicCourseDetails.masterUserId = master.userId;
    },
    convertNumbers2English(number) {
      return number.replace(/[\u0660-\u0669\u06f0-\u06f9]/g, function (c) {
        return c.charCodeAt(0) & 0xf;
      });
    },
  },
  computed: {
    formattedTermicCoursePrice: {
      get() {
        return this.termicCourseDetails.price;
      },
      set(newValue) {
        // This setter is getting number, replace all commas with empty str
        // Then start to separate numbers with ',' from beginning to prevent
        // from data corruption
        if (newValue) {
          this.termicCourseDetails.price = this.convertNumbers2English(newValue)
            .toString()
            .replaceAll(",", "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

          // Remove all characters that are NOT number
          this.termicCourseDetails.price =
            this.termicCourseDetails.price.replace(
              /[a-zA-Z+*!@#$%^&*()_;:'"|<>/?{}\u0600-\u06EC/\-/\.]/g,
              ""
            );
        } else if (!newValue || newValue === "") {
          this.termicCourseDetails.price = "";
        }
      },
    },
    formattedTermicCourseDiscountPrice: {
      get() {
        return this.termicCourseDetails.discountPrice;
      },
      set(newValue) {
        // This setter is getting number, replace all commas with empty str
        // Then start to separate numbers with ',' from beginning to prevent
        // from data corruption
        if (newValue) {
          this.termicCourseDetails.discountPrice = this.convertNumbers2English(
            newValue
          )
            .toString()
            .replaceAll(",", "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

          // Remove all characters that are NOT number
          this.termicCourseDetails.discountPrice =
            this.termicCourseDetails.discountPrice.replace(
              /[a-zA-Z+*!@#$%^&*()_;:'"|<>/?{}\u0600-\u06EC/\-/\.]/g,
              ""
            );
        } else if (!newValue || newValue === "") {
          this.termicCourseDetails.discountPrice = "";
        }
      },
    },

    formattedMasterIncome: {
      get() {
        return this.termicCourseDetails.masterIncome;
      },
      set(newValue) {
        // This setter is getting number, replace all commas with empty str
        // Then start to separate numbers with ',' from beginning to prevent
        // from data corruption
        if (newValue) {
          this.termicCourseDetails.masterIncome = this.convertNumbers2English(
            newValue
          )
            .toString()
            .replaceAll(",", "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

          // Remove all characters that are NOT number
          this.termicCourseDetails.masterIncome =
            this.termicCourseDetails.masterIncome.replace(
              /[a-zA-Z+*!@#$%^&*()_;:'"|<>/?{}\u0600-\u06EC/\-/\.]/g,
              ""
            );
        } else if (!newValue || newValue === "") {
          this.termicCourseDetails.masterIncome = "";
        }
      },
    },
  },
  components: {
    PageWrapper,
    BButton,
    TextInput,
    CustomDatePicker,
    LanguagePicker,
    MasterPicker,
    WeekDaysCheckBoxGroup,
    TermicCourseStudentList,
    BRow,
    BCol,
    BFormGroup,
    BFormFile,
    BImg,
    CustomEditor,
  },
};
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import TextInput from "@/views/components/Utils/TextInput.vue";
import CustomDatePicker from "@/views/components/Utils/CustomDatePicker.vue";
import LanguagePicker from "@/views/components/Language/LanguagePicker.vue";
import MasterPicker from "@/views/components/MasterActiveCourse/MasterPicker.vue";
import WeekDaysCheckBoxGroup from "@/views/components/TermicCourses/WeekDaysCheckBoxGroup.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import TermicCourseStudentList from "@/views/apps/TermicCourses/TermicCourseStudentList.vue";
import CustomEditor from "@/views/components/Utils/CustomEditor.vue";

import {
  BRow,
  BCol,
  BButton,
  BFormGroup,
  BFormFile,
  BImg,
} from "bootstrap-vue";
import {
  GetTermicCourseById,
  UpdateTermicCourse,
} from "@/libs/Api/TermicCourses";
import { UploadImage } from "@/libs/Api/Uploader";
</script>
<style scoped>
.custom-image {
  max-height: 200px;
}
.custom-delete-btn {
  position: absolute !important;
  right: 0 !important;
  top: 0 !important;
}
</style>
